import * as React from 'react';
import GoogleMapReact from 'google-map-react';
import { className } from '../../util';
import { ViewProp } from '..';
import * as mrCap from '../../mrCapTypes';
import { Shop } from './shop';
import * as api from '../../api/booking';

interface Props extends ViewProp {
  shops: mrCap.Shop[];
  splitLayout?: boolean;
  shopChangedMessage: string;
  updateTimes?: (shopId: number) => void;
}

export function MapWithShops (props: Props) {
  const isMobile = window.innerWidth <= 750;

  const initialListState = () => {
    if (isMobile && props.splitLayout) {
      return false;
    }

    if (!isMobile && props.splitLayout) {
      return true;
    }

    return false;
  };

  const [viewingShopList, toggleShopList] = React.useState(initialListState);
  const [findShop, searchShop] = React.useState('');
  const [shopChangedMessage, toggleShopChangedMessage] = React.useState(false);

  const initialMapZoom = 9;
  const mapZoom = props.selectedShop
    ? {lat: props.selectedShop.lat as number, lng: props.selectedShop.lng as number}
    : {lat: 57.57876591814119, lng: 14.464190007723296};

  const elementHeight = 370;

  const shopChanged = async (shop: mrCap.Shop) => {

    if (props.selectedProducts.length > 0 && props.selectedShop !== shop) {
      toggleShopChangedMessage(true);

      setTimeout(() => {
        toggleShopChangedMessage(false);
      }, 4000);

      try {
        const productsResponse = await api.getProducts(shop.id, props.regNr);
        props.updateSelectedProducts(productsResponse.products);
      } catch (error) {
        console.error(error);
      }

    }

    props.setShop(shop);
  };

  return(<>
    <div className={className('shops', { 'split-layout': props.splitLayout })}
      onMouseEnter={() => props.splitLayout ? (isMobile ? toggleShopList(true) : null) : toggleShopList(true)}
      onMouseLeave={() => props.splitLayout ? (isMobile ? toggleShopList(false) : null) : toggleShopList(false)}>
      <div className='shop-selector'>
        <input
          type='text'
          placeholder='Sök anläggning'
          value={findShop}
          onChange={e => searchShop(e.target.value)}/>
        <i className='fas fa-search'></i>
      </div>
      <div className={className('shop-dropdown', { 'dropdown-opened': viewingShopList })}>
        {props.shops.filter(shopstr => {
          return shopstr.name.toLowerCase().includes(findShop.toLowerCase());
        }).map(shops =>
          <Shop
            key={shops.id}
            shop={shops}
            selectedShop={props.selectedShop}
            click={shopChanged}
            updateTimes={id => props.updateTimes && props.updateTimes(id)} />
        )}
      </div>
    </div>
    {props.shops.length > 0 && <>
      <div style={{height: elementHeight}} className={className('map', { 'split-layout': props.splitLayout })}>

        {props.shopChangedMessage &&
          <div className={className('shop-changed-message', { visible: shopChangedMessage })}
            dangerouslySetInnerHTML={{ __html: props.shopChangedMessage }}></div>}

        <GoogleMapReact
          bootstrapURLKeys={{ key: 'AIzaSyC-Kir97FroXGXABb3Vm8P8am9APPzKBqY' }}
          center={mapZoom}
          defaultZoom={initialMapZoom}
          yesIWantToUseGoogleMapApiInternals>
          {props.shops.map(shop =>
            <Markers
              shop={shop}
              lat={shop.lat}
              lng={shop.lng}
              click={shopChanged}
              updateTimes={() => props.updateTimes && props.updateTimes(shop.id)}
              key={shop.id}
              selectedShop={props.selectedShop} />)}
        </GoogleMapReact>
      </div>
    </>}
    <div className={className('chosen-hint', {
      active: props.selectedShop !== null,
      'split-layout': props.splitLayout })}>
      {props.selectedShop
        ? <>
          <div className='shop-name'><strong>Vald anläggning: </strong>{props.selectedShop.name}</div>
          <div className='info'><strong>Adress: </strong> {props.selectedShop.address}</div>
          <div className='info'><strong>Telefon: </strong> {props.selectedShop.phone}</div>
          <div className='info'><strong>E-post: </strong> {props.selectedShop.email}</div></>
        : 'Ingen anläggning vald ännu'}
    </div>
  </>);
}

interface MarkerProps {
  shop: mrCap.Shop;
  selectedShop: mrCap.Shop | null;
  click: (shop: mrCap.Shop) => void;
  updateTimes: (id: number) => void;
  lat: number | undefined;
  lng: number | undefined;
}

function Markers({shop, selectedShop, click, updateTimes}: MarkerProps) {

  const handleClick = () => {
    click(shop);
    updateTimes(shop.id);
  };

  return (
    <div className='marker'>
      <div className={className('marker-inner', { active: selectedShop && selectedShop.id === shop.id })}
        onClick={handleClick}>
        <i className='fas fa-map-marker'></i>
      </div>
    </div>
  );
}